import _ from 'lodash'

import { mergeConfig } from '@/utils'

export const DEFAULT_CONFIG = {
  customCss: '',
  minGiftPrice: 0, // ￥0.0
  minTickerPrice: 0.1, // ￥0.1
  showDanmaku: true,
  showInteractWordEnter: false,
  showInteractWordFollow: false,
  showInteractWordShare: false,
  showTranslateDanmakuOnly: false,
  allowTextColorSetting: true,
  blockTranslateDanmaku: false,
  translationSign: '【',
  showSuperchat: true,
  showNewMember: true,
  showGift: true,
  showGiftInfo: true,
  mergeSameUserDanmaku: false,
  mergeSameUserDanmakuInterval: 60,
  mergeSimilarDanmaku: false,
  mergeGift: false,
  danmakuAtBottom: true,
  tickerAtButtom: false,
  randomXOffset: false,
  randomXRangeMin: 0,
  randomXRangeMax: 100,
  randomYOffset: false,
  randomYRangeMin: 250,
  randomYRangeMax: 500,
  randomXInitialOffset: 0,
  randomYInitialOffset: 0,
  floatDistanceXMin: 0,
  floatDistanceXMax: 0,
  floatDistanceYMin: 0,
  floatDistanceYMax: 0,
  floatDistanceThreshold: 0,
  floatTime: 60,
  maxNumber: 30,
  fadeOutNum: 3,
  pinTime: 0,

  useLocalEmoticonSetting: false,
  autoRenderOfficialSmallEmoji: true,
  autoRenderOfficialGeneralEmoji: true,
  autoRenderStreamerEmoji: true,
  autoRenderPersonalEmoji: true,


  isGreedyMatch: true,
  isSkipSameImage: false,
  imageShowType: 0,
  maxEmoji: 500,
  maxImage: 100,

  blockGiftDanmaku: true,
  blockLevel: 0,
  blockNewbie: false,
  blockNotMobileVerified: false,
  blockKeywords: '',
  blockUsers: '',
  blockUsersByKeywords: '',
  blockMedalLevel: 0,

  minDanmakuInterval: 1500,
  maxDanmakuInterval: 1500,

  relayMessagesByServer: false,
  autoTranslate: false,
  giftUsernamePronunciation: '',

  emoticons: [],
}

// 客户端使用的配置
export const CLIENT_CONFIG = {
  showMsg: true, // 是否显示游客消息
  minLevel: 0, // 最小显示等级
  showCaptainMsg: true, // 舰长消息显示
  showAdmiralMsg: true, // 提督消息显示
  showGovernorMsg: true, // 总督消息显示
  showSuperchat: true, // 付费醒目消息显示
  minScPrice: 0, // 付费醒目消息显示最小显示金额
  showGift: true, // 赠送礼物消息显示
  minGiftPrice: 0, // 赠送礼物消息显示显示最小显示金额
  maxNumber: 30, // 最大显示弹幕数量
  lang: "zh",
  skin: "", // 客户端自定义皮肤
  textFontSize: 20, // 客户端自定义调整字体大小
  textEmoticonsSize: 80, // 客户端自定义调整表情包大小
}

// 送礼播报配置
export const GIFT_CONFIG = {
  // 送礼是否显示
  showGift: true,
  minGiftPrice: 0,
  // 是否显示舰长上舰
  showCaptain: true,
  // 是否显示提督上舰
  showAdmiral: true,
  // 是否显示总督上舰
  showGovernor: true,
  // 皮肤
  skin: ''

}


export function deepCloneDefaultConfig() {
  return _.cloneDeep(DEFAULT_CONFIG)
}

export function setLocalConfig(config) {
  config = mergeConfig(config, DEFAULT_CONFIG)
  window.localStorage.setItem('xjy_config', JSON.stringify(config))
}

export function getLocalConfig() {
  try {
    let config = JSON.parse(window.localStorage.getItem('xjy_config') || '{}')
    config = mergeConfig(config, deepCloneDefaultConfig())
    sanitizeConfig(config)
    return config
  } catch {
    return deepCloneDefaultConfig()
  }
}

export function sanitizeConfig(config) {
  let newEmoticons = []
  if (config.emoticons instanceof Array) {
    for (let emoticon of config.emoticons) {
      try {
        let newEmoticon = {
          keyword: emoticon.keyword,
          level: emoticon.level,
          align: emoticon.align,
          height: emoticon.height,
          url: emoticon.url
        }
        if ((typeof newEmoticon.keyword !== 'string') || (typeof newEmoticon.url !== 'string') || (typeof newEmoticon.align !== 'string') || (typeof newEmoticon.height !== 'number') || (typeof newEmoticon.level !== 'number')) {
          continue
        }
        newEmoticons.push(newEmoticon)
      } catch {
        continue
      }
    }
  }
  config.emoticons = newEmoticons
}
